/* eslint-disable no-param-reassign */
import produce from 'immer';
import { GET_NOTIFICATIONS } from 'src/actions/notificationsActions';

const initialState = {
  notifications: []
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS: {
      //Esto es ES6 - Basicamente es declarame "notifications" con el "notifications" de adentro de action.payload.
      //const { notifications } = action.payload;
      const notifications = action.payload;
      return produce(state, (draft) => {
        draft.notifications = notifications;
      });
    }

    default: {
      //debugger;
      return state;
    }
  }
};

export default notificationsReducer;
